module.exports = __webpack_public_path__ + "static/reward-modal-icon.0ebcde81.png";